import { render, staticRenderFns } from "./PayMeWidget.vue?vue&type=template&id=1367fb66&"
import script from "./PayMeWidget.vue?vue&type=script&lang=js&"
export * from "./PayMeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports